import Label from "./Label.jsx";
import { theme } from "../../theme.js";

export default function Input ({label, name, value, setFormData, type="text", width="100%", required=false, disabled=false, multiline=false, rows=4, placeholder}) {
    const handleChange = (e) => {
        if (disabled) return;
        const { name, value } = e.target;
        setFormData((s) => ({ ...s, [name]: value }));
    };
    
    const onPaste = (e) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        setFormData((s) => ({ ...s, [e.target.name]: e.clipboardData.getData('text') }));
    };

    const sharedProps = {
        name,
        value,
        onChange: handleChange,
        style: { ...styles(theme, disabled).input, width },
        placeholder: placeholder || label,
        onPaste,
        disabled,
    };

    return (
    <div style={styles(theme, disabled).div}>
        <Label label={label} required={required}/>
        <div/>
        {multiline ? (
            <textarea
                {...sharedProps}
                rows={rows}
                style={{ ...sharedProps.style, resize: "vertical", minHeight: `${rows * 1.6}em`, fontSize: "16px" }}
            />
        ) : (
            <input {...sharedProps} type={type} />
        )}
    </div>
 );
}

const styles = (theme, disabled = false) => ({
    div: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing.lg,
    width: "100%",
  },
input: {
    padding: `${theme.spacing.md} ${theme.spacing.sm}`,
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.border}`,
    fontSize: theme.fonts.size.sm,
    marginTop: theme.spacing.xs,
    width: "100%",
    boxSizing: "border-box",
    display: "block",
    fontFamily: "inherit",
    color: disabled ? theme.colors.textMuted : theme.colors.textInverted,
    backgroundColor: disabled ? theme.colors.bgLight : "transparent",
    cursor: disabled ? "not-allowed" : "text",
    opacity: disabled ? 0.6 : 1,
  },
});
